var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.875C3 4.29257 3 4.00136 3.09515 3.77165C3.22202 3.46536 3.46536 3.22202 3.77165 3.09515C4.00136 3 4.29257 3 4.875 3C5.45743 3 5.74864 3 5.97835 3.09515C6.28464 3.22202 6.52798 3.46536 6.65485 3.77165C6.75 4.00136 6.75 4.29257 6.75 4.875V11.125C6.75 11.7074 6.75 11.9986 6.65485 12.2284C6.52798 12.5346 6.28464 12.778 5.97835 12.9049C5.74864 13 5.45743 13 4.875 13C4.29257 13 4.00136 13 3.77165 12.9049C3.46536 12.778 3.22202 12.5346 3.09515 12.2284C3 11.9986 3 11.7074 3 11.125V4.875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25031 4.875C9.25031 4.29257 9.25031 4.00136 9.34546 3.77165C9.47232 3.46536 9.71567 3.22202 10.022 3.09515C10.2517 3 10.5429 3 11.1253 3C11.7077 3 11.9989 3 12.2287 3.09515C12.5349 3.22202 12.7783 3.46536 12.9052 3.77165C13.0003 4.00136 13.0003 4.29257 13.0003 4.875V11.125C13.0003 11.7074 13.0003 11.9986 12.9052 12.2284C12.7783 12.5346 12.5349 12.778 12.2287 12.9049C11.9989 13 11.7077 13 11.1253 13C10.5429 13 10.2517 13 10.022 12.9049C9.71567 12.778 9.47232 12.5346 9.34546 12.2284C9.25031 11.9986 9.25031 11.7074 9.25031 11.125V4.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.419f104de1000e02e48a2e1b7d850f37.svg";
export { ForwardRef as ReactComponent };